export const navbarLinks = [
  {
    id: 1,
    text: 'men',
    path: '/',
  },
  {
    id: 2,
    text: 'women',
    path: '/',
  },
  {
    id: 3,
    text: 'unisex',
    path: '/',
  },
  {
    id: 4,
    text: 'kids',
    path: '/',
  },
  {
    id: 5,
    text: 'best sellers',
    path: '/',
  },
  {
    id: 6,
    text: 'new arrivals',
    path: '/',
  },
  {
    id: 7,
    text: 'offers',
    path: '/',
  },
];
